<template>
  <div class="document-create-form-container">
    <div class="tab-header-container">
      <h2 class="form-label">Създаване на документ</h2>
      <LiteButton @click.native="close"
                  style="font-size: 35px; float: right;"
                  class="edit-button"
                  :hoverColor="'red'"
                  :icon="'far fa-window-close'">
      </LiteButton>
    </div>

    <hr class="form-line" style="margin-bottom: 20px;"/>

    <div class="document-fields-container" v-if="selectedDocumentDefinition">
      <SelectDropDown v-if="documentDefinitions"
                      class="document-add-dropdown"
                      style="margin-bottom: 20px;"
                      :id="'documentName'"
                      :name="'documentName'"
                      :options="documentDefinitions"
                      :defaultSelected="documentDefinitions[0]"
                      :label="'Тип документ'"
                      @selection-change="documentDefinitionChange"
      />

      <div>
        <label class="document-datepicker-label">Дата на издаване</label>
        <date-picker v-model="startDate"
                     type="date"
                     :format="'DD-MM-YYYY'"
                     :lang="{formatLocale: getFormatLocale()}"
                     class="document-edit-datepicker"
                     placeholder="Изберете дата"/>
        <ErrorInput class="error" v-if="shouldShowError('startDate')" :text="errors['startDate']"/>
      </div>

      <div>
        <label class="document-datepicker-label">Дата на изтичане</label>
        <date-picker v-model="endDate"
                     type="date"
                     :format="'DD-MM-YYYY'"
                     :lang="{formatLocale: getFormatLocale()}"
                     class="document-edit-datepicker"
                     placeholder="Изберете дата"/>
      </div>

      <SelectDropDown v-if="countries && selectedDocumentDefinition.name !== 'Други'"
                      class="document-add-dropdown"
                      style="margin-bottom: 20px;"
                      :id="'countryDropdown'"
                      :name="'country'"
                      :options="countries"
                      :placeholder="'Изберете държава'"
                      :label="'Държава'"
                      @selection-change="setCountry"
      />

      <div v-for="field in selectedDocumentDefinition.fieldDefinitions" :key="field.selector">
        <InputText
            v-if="field.selector !== 'description'"
            class="document-input-field"
            :label="field.name"
            :name="field.selector"
            @value-change="fieldValueChanged"
            :id="field.selector + ''"/>

        <div class="form-description-container" v-if="field.selector === 'description'">
          <p class="document-description-label label">Описание:</p>
          <textarea class="document-description-text-area" v-model="document.fieldValues['description']">
            </textarea>
        </div>
      </div>

      <Button class="save-button"
              @click.native="saveDocument"
              :color="'green'"
              :text="'Запази'"
              :icon="'fa fa-save'"></Button>

    </div>
  </div>
</template>

<script>
import InputText from "@/shared/components/form/InputText";
import Button from "@/shared/components/button/Button";
import SelectDropDown from "@/shared/components/form/SelectDropDown";
import dateService from "@/services/date.service";
import DatePicker from 'vue2-datepicker';
import documentService from "@/services/document.service";
import LiteButton from "@/shared/components/button/LiteButton"
import sharedService from "@/services/shared.service";
import ErrorInput from "@/shared/components/form/ErrorInput";

export default {
  name: "DocumentCreateForm",
  components: {ErrorInput, Button, InputText, DatePicker, SelectDropDown, LiteButton},
  props: {
    workerId: Number
  },
  created() {
    documentService.fetchDocumentDefinitions()
        .then(({data}) => {
          this.documentDefinitions = data;
          this.selectedDocumentDefinition = this.documentDefinitions[0];
        });

    sharedService.fetchCountries()
        .then(({data}) => {
          data.forEach((country) => country.id = country.iso);
          this.countries = data
        });
  },
  data() {
    return {
      document: {
        fieldValues: {}
      },
      selectedDocumentDefinition: null,
      documentDefinitions: null,
      countries: null,
      startDate: null,
      endDate: null,
      errors: {startDate: null}
    }
  },
  methods: {
    close() {
      this.$emit('close-clicked', {});
    },
    shouldShowError(fieldName) {
      return !!(this.errors && this.errors[fieldName]);
    },
    documentDefinitionChange(value) {
      this.selectedDocumentDefinition = value.currentValue;
      this.document = {
        fieldValues: {}
      };
    },
    setCountry(value) {
      this.document.countryIso = value.currentValue.iso;
    },
    fieldValueChanged(event) {
      this.document.fieldValues[event.name] = event.currentValue;
    },
    saveDocument() {
      this.document.definitionId = this.selectedDocumentDefinition.id;
      this.document.workerId = this.workerId;
      documentService.createDocument(this.document)
          .then(() => {
            this.$emit('close-clicked', {});
          })
          .catch((errors) => this.errors = errors.response.data.errors);
    },
    getFormatLocale() {
      return dateService.getFormatLocale();
    }
  }
  ,
  computed: {}
  ,
  watch: {
    startDate: {
      handler(newVal) {
        this.errors['startDate'] = null;
        if (newVal) {
          this.document.startDate = dateService.formatDateISO(newVal);
        } else {
          this.document.startDate = null;
        }
      },
      deep: true
    },
    endDate: {
      handler(newVal) {
        this.errors['startDate'] = null;
        if (newVal) {
          this.document.endDate = dateService.formatDateISO(newVal);
        } else {
          this.document.endDate = null;
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
@import "../../css/shared/input.css";

.document-create-form-container {
  width: 900px;
  height: fit-content;
  margin: 50px auto;
  padding: 20px;
  z-index: 120;
  background-color: #ffffff;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.document-fields-container {
  width: 80%;
  margin: 0 auto 30px auto;
  display: inline-block;
}

.save-button {
  width: 300px;
  height: 60px;
  font-size: 26px;
  margin: 45px;
}

.document-input-field {
  height: 90px;
  width: 80%;
  margin: 20px 0;
}

.document-edit-datepicker {
  float: left;
  margin: 0 10% 20px 10%;
}

.document-add-dropdown {
  width: 80%;
  margin: 20px 0;
}

.document-datepicker-label {
  float: left;
  height: 30px;
  width: 100%;
  text-align: left;
  margin-left: 10%;
  margin-top: 20px;
  font-size: 20px;
  color: var(--dark-grey);
}

.form-description-container {
  display: inline-block;
  width: 80%;
  height: 200px;
  margin: 20px 10%;
}

.document-description-label {
  width: 100%;
}

.document-description-text-area {
  width: 100%;
  height: 100%;
}

</style>
